// Image placeholder while new project photos are being uploaded
const PLACEHOLDER =
  "data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%20800%20600%27%3E%3Cdefs%3E%3Cpattern%20id%3D%27g%27%20width%3D%2740%27%20height%3D%2740%27%20patternUnits%3D%27userSpaceOnUse%27%3E%3Cpath%20d%3D%27M%2040%200%20L%200%200%200%2040%27%20fill%3D%27none%27%20stroke%3D%27%23383330%27%20stroke-width%3D%270.5%27%2F%3E%3C%2Fpattern%3E%3C%2Fdefs%3E%3Crect%20width%3D%27800%27%20height%3D%27600%27%20fill%3D%27%23292524%27%2F%3E%3Crect%20width%3D%27800%27%20height%3D%27600%27%20fill%3D%27url(%23g)%27%2F%3E%3Ctext%20x%3D%27400%27%20y%3D%27280%27%20font-family%3D%27Georgia%2C%20serif%27%20font-size%3D%2796%27%20fill%3D%27%23fafaf9%27%20text-anchor%3D%27middle%27%20font-style%3D%27italic%27%3EM%3Ctspan%20fill%3D%27%23ea580c%27%3E%26amp%3B%3C%2Ftspan%3EL%3C%2Ftext%3E%3Ctext%20x%3D%27400%27%20y%3D%27330%27%20font-family%3D%27ui-monospace%2C%20monospace%27%20font-size%3D%2713%27%20fill%3D%27%23a8a29e%27%20text-anchor%3D%27middle%27%20letter-spacing%3D%273%27%3EIMAGE%20PENDING%20%C2%B7%20NEW%20PROJECT%20PHOTOS%3C%2Ftext%3E%3Ctext%20x%3D%27400%27%20y%3D%27360%27%20font-family%3D%27ui-monospace%2C%20monospace%27%20font-size%3D%2711%27%20fill%3D%27%23ea580c%27%20text-anchor%3D%27middle%27%20letter-spacing%3D%274%27%3E%E2%80%94%20M%26amp%3BL%20HARDSCAPES%20%E2%80%94%3C%2Ftext%3E%3C%2Fsvg%3E";

// Real M&L Exterior and Interior Design project imagery
const IMG = {
  hero: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/ajmsmp8i_IMG_7464.webp",
  patio_circular: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/k3qnbk61_IMG_7277.jpeg",
  pool_deck: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/7i490t9i_IMG_7194.jpeg",
  modern_drive: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/agtn5y68_IMG_7193.jpeg",
  flagstone_walk: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/el1d1ok7_IMG_7199.jpeg",
  ashlar_pavers: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/cjfdks89_IMG_7197.jpeg",
  medallion_drive: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/ie45ezz6_IMG_7171.webp",
  // Flooring — interior
  lvp_kitchen: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/gkk741il_IMG_7771.jpeg",
  lvp_basement: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/ud9ci9kn_2F372B81-94D2-480F-B9D3-8B7BE4993A4D.png",
  tile_hex_bath: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/9z6zytzm_IMG_7768.jpeg",
  tile_marble_bath: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/yt2o49vq_IMG_7767.jpeg",
  tile_marble_living: "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/5fuiwjzx_IMG_7766.jpeg",
  // New flooring installs
  dark_hardwood_kitchen: "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/4wknacka_IMG_8732.jpeg",
  gray_plank_tile: "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/jgfqf5bq_IMG_8261.jpeg",
  herringbone_foyer: "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/bd1eb7qe_IMG_8258.jpeg",
  light_lvp_living: "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/jbx7b3xk_IMG_8221.jpeg",
  gray_lvp_office: "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/lpr2y0ty_IMG_8220.jpeg",
  // Newly added — Feb 2026 install shots
  weathered_lvp_dining:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/paytz0q5_IMG_8223.jpeg",
  dark_lvp_fireplace:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/xo198ivi_IMG_8222.jpeg",
  light_oak_family:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/ipk2asyx_IMG_8221.jpeg",
  gray_lvp_commercial:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/oo6v3oj1_IMG_8220.jpeg",
  marble_master_bath:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_hardscape-pro-5/artifacts/x7m4cm17_IMG_8219.jpeg",
};

export const HERO_IMG = IMG.tile_marble_living;

export const SERVICES = [
  {
    id: "laminate",
    title: "Laminate Flooring",
    description:
      "The look of real hardwood at a fraction of the cost. Ultra-hard wear layer resists scratches, fading, and daily traffic better than actual wood. A smart, elegant choice for living rooms, bedrooms, and hallways.",
    image: IMG.dark_hardwood_kitchen,
    alt: "M&L Exterior and Interior Design — Dark hardwood-look laminate flooring in white kitchen",
    features: [
      "Scratch & fade resistant",
      "Wide range of wood-look styles",
      "Fast, clean install · flush transitions",
    ],
  },
  {
    id: "lvp",
    title: "LVP Flooring",
    description:
      "Luxury Vinyl Plank — 100% waterproof, incredibly durable, and virtually indistinguishable from real hardwood. Perfect for kitchens, basements, bathrooms, and homes with kids or pets. Level subfloor prep and precision plank cuts every time.",
    image: IMG.lvp_basement,
    alt: "M&L Exterior and Interior Design — Wide-plank LVP flooring installation in luxury basement",
    features: [
      "100% waterproof",
      "Scratch & dent resistant",
      "Level subfloor prep + moisture barrier",
    ],
  },
  {
    id: "tile",
    title: "Tile Installation",
    description:
      "Where our precision really shines. From large-format marble-look tile to intricate hex mosaics and herringbone patterns — every cut scored on-site for tight grout lines and flush transitions. Built to last decades.",
    image: IMG.tile_hex_bath,
    alt: "M&L Exterior and Interior Design — Hexagonal tile installation in primary bathroom with marble shower",
    features: [
      "Hex · Marble · Herringbone · Mosaic",
      "Fully waterproof · lifetime durability",
      "Bathrooms · Kitchens · Entryways",
    ],
  },
];

export const PORTFOLIO = [
  {
    image: IMG.lvp_basement,
    title: "Wide-Plank LVP Basement",
    type: "LVP Flooring · O'Fallon",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    image: IMG.tile_marble_living,
    title: "Marble-Look Tile Living Room",
    type: "Large-Format Tile · Chesterfield",
    span: "md:col-span-5 md:row-span-1",
  },
  {
    image: IMG.marble_master_bath,
    title: "Calacatta Marble Primary Bath",
    type: "Tile Installation · Wentzville",
    span: "md:col-span-5 md:row-span-1",
  },
  {
    image: IMG.weathered_lvp_dining,
    title: "Weathered-Oak LVP Dining Room",
    type: "LVP Flooring · Cottleville",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    image: IMG.dark_lvp_fireplace,
    title: "Espresso LVP Living Room",
    type: "LVP Flooring · St. Peters",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    image: IMG.light_oak_family,
    title: "Light-Oak Open-Plan Family Room",
    type: "LVP Flooring · Lake St. Louis",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    image: IMG.tile_hex_bath,
    title: "Hex-Tile Primary Bath",
    type: "Tile Installation · St. Charles",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    image: IMG.dark_hardwood_kitchen,
    title: "Dark Hardwood Kitchen",
    type: "Laminate Flooring · Wentzville",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    image: IMG.gray_lvp_commercial,
    title: "Gray LVP Office Buildout",
    type: "Commercial LVP · O'Fallon",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    image: IMG.herringbone_foyer,
    title: "Herringbone Tile Foyer",
    type: "Custom Tile Pattern · St. Peters",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    image: IMG.light_lvp_living,
    title: "Light-Oak LVP Great Room",
    type: "LVP Flooring · Dardenne Prairie",
    span: "md:col-span-12 md:row-span-1",
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Consultation",
    description:
      "We walk the space, measure the rooms, listen to how you live in them, and match the right material (laminate, LVP, or tile) to your budget and lifestyle.",
  },
  {
    n: "02",
    title: "Design & Selection",
    description:
      "Detailed material selection, layout mockups, transitions, and a transparent line-item quote — no surprises before install day.",
  },
  {
    n: "03",
    title: "Installation",
    description:
      "Subfloor leveled and moisture-sealed. Precision plank & tile cuts. Tight seams. Flush transitions. Every step inspected before we move on.",
  },
  {
    n: "04",
    title: "Lasting Beauty",
    description:
      "We finish, seal, and walk you through care. Then we stand by it — long after the final piece is set.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Highly recommend! They transformed my old carpet into beautiful luxury LVP flooring. The work was professional, fast, and the results exceeded my expectations. Great quality and great service!",
    name: "Verified Google Review",
    project: "LVP Flooring · Carpet Replacement",
  },
  {
    quote:
      "M&L Exterior and Interior Design did a great job! My LVP flooring looks awesome. They were on time, professional, and paid great attention to detail. The installation was smooth, and I'm very happy with the final result. I highly recommend them to anyone looking for quality flooring installation!",
    name: "Verified Google Review",
    project: "LVP Flooring Installation",
  },
  {
    quote:
      "Excellent ceramic tile installation! Great attention to detail, clean work, and beautiful results. Highly recommend!",
    name: "Verified Google Review",
    project: "Ceramic Tile Installation",
  },
];

export const STATS = [
  { value: "12+", label: "Years building" },
  { value: "240+", label: "Projects completed" },
  { value: "100%", label: "Licensed & insured" },
  { value: "5★", label: "Average rating" },
];

export const SERVICE_AREAS = [
  // St. Charles County
  "St. Charles",
  "O'Fallon",
  "Wentzville",
  "St. Peters",
  "Lake St. Louis",
  "Cottleville",
  "Dardenne Prairie",
  "Weldon Spring",
  "New Melle",
  "Augusta",
  "Foristell",
  "Portage des Sioux",
  "West Alton",
  "Flint Hill",
  "Josephville",
  // St. Louis (City + County)
  "St. Louis",
  "Chesterfield",
  "Clayton",
  "Kirkwood",
  "Webster Groves",
  "Ballwin",
  "Ellisville",
  "Wildwood",
  "Town and Country",
  "Ladue",
  "Creve Coeur",
  "Maryland Heights",
  "Florissant",
  "Hazelwood",
  "Bridgeton",
  "University City",
  "Manchester",
  "Des Peres",
  "Frontenac",
  "Sunset Hills",
  "Fenton",
  "Arnold",
  "Oakville",
  "Affton",
];
